/**
 * Money and rates on a PO line, as PLAIN NUMBERS.
 *
 * Aaron, 17 Sep 2026, walking PR 2 against the legacy grid: *"there is already
 * a currency field on the PO line, so in the unit price field we don't need the
 * $... in the old platform these are just 2dp numbers, they should not be
 * alphanumeric — this can mess with when people are exporting the data."*
 *
 * Two reasons, and the second is the load-bearing one:
 *
 * 1. The currency is its OWN field on the line and its own column in the grid,
 *    so a glyph beside every figure restates it — and restates it WRONGLY the
 *    moment the glyph and the field disagree (a USD line rendering "£").
 * 2. A figure carrying a symbol or a thousands separator stops being a number
 *    when it reaches a spreadsheet. `$2,000.00` is text; `2000.00` is 2000.
 *
 * So: fixed decimals, a leading minus where the value is negative, and nothing
 * else — no symbol, no grouping separator, no locale.
 */

/**
 * @param value - The amount, as the API sends it (string) or a number.
 * @param decimals - Places to fix to. 2 unless the caller has a tenant setting
 *   that says otherwise (unit prices carry `unit_price_decimals`).
 * @returns e.g. "2000.00"; '' when there is no usable number, so a caller can
 *   render its own placeholder rather than "NaN" or a misleading "0.00".
 */
export function formatAmount(
  value: string | number | null | undefined,
  decimals = 2,
): string {
  if (value === null || value === undefined || value === '') return '';
  const numeric = typeof value === 'number' ? value : parseFloat(value);
  if (!Number.isFinite(numeric)) return '';
  return numeric.toFixed(decimals);
}
